export const enCohortsPageTranslations = {
  CohortsPage: {
    title: 'Cohorts',
    newCohortWithAgent: 'New cohort with agent',
    search: 'Search cohorts',
    clearSearch: 'Clear search',
    organization: 'Organization',
    uncategorized: 'Uncategorized — not shown in Filters',
    uncategorizedName: 'Uncategorized',
    draft: 'Draft',
    draftBy: 'Draft by {{author}}',
    alsoIn: 'Also in: {{categories}}',
    usedBy_one: 'Used by {{count}} view',
    usedBy_other: 'Used by {{count}} views',
    excludedBy_one: 'Excluded by {{count}} view',
    excludedBy_other: 'Excluded by {{count}} views',
    excludedBy_combined_one: 'excluded by {{count}} view',
    excludedBy_combined_other: 'excluded by {{count}} views',
    notUsed: 'Not used by any view',
    references: 'Built on',
    includes: 'Includes: {{base}}',
    allPatients: 'All patients, including discharged',
    loading: 'Loading cohorts',
    empty: 'No cohorts yet',
    noMatches: 'No cohorts match “{{search}}”.',
    emptyCategory:
      'No cohorts in this category yet. Its Filters section is hidden until it has one.',
    allCategorized: 'Every cohort is in at least one category.',
    loadFailed: 'Could not load cohorts.',
    retry: 'Try again',
    done: 'Done',
    close: 'Close',
    writeDialogDescription: 'Manage the selected cohort or category.',
    conflictOrganization: 'the organization',
    conflictOtherWorkspace: 'another workspace',
    objects: { cohort: 'cohort', category: 'category', view: 'view' },
    refreshFailed:
      'Couldn’t refresh the list. Reload the page to see the latest cohorts and categories.',
    save: 'Save',
    rename: 'Rename',
    delete: 'Delete',
    editWithChat: 'Edit with chat',
    openDraft: 'Open draft',
    categoryActions: '{{name}} category actions',
    cohortActions: '{{name}} cohort actions',
    newCategory: 'New category',
    categoryName: 'Name',
    categoryNamePlaceholder: 'Category name',
    belongsTo: 'Belongs to',
    scopeOrganization: 'Entire organization',
    scopeOrganizationHint: 'Holds organization cohorts. Same section in every workspace.',
    scopeWorkspaceHint:
      'Holds organization cohorts and {{workspace}} cohorts. Only in {{workspace}}.',
    draftNote:
      'A new category is a draft (“Draft by …”) until a cohort in it is published. Its scope can’t be changed later.',
    createCategory: 'Create category',
    categoryCreated:
      'Created {{name}} as a draft. It appears in Filters once a cohort in it is published.',
    renameCategoryTitle: 'Rename “{{name}}”',
    categoryRenamed: 'Renamed {{from}} to {{to}}',
    deleteCategory: 'Delete category',
    deleteCategoryTitle: 'Delete “{{name}}”?',
    categoryHasNoCohorts: 'It has no cohorts.',
    categoryCohortsLeave_one: 'Its {{count}} cohort leaves this section.',
    categoryCohortsLeave_other: 'Its {{count}} cohorts leave this section.',
    categoryDeleteEffect:
      'Cohorts in no other category become uncategorized. Views keep their saved filters.',
    willBeUncategorized: 'Becoming uncategorized: {{names}}.',
    categoryDeletedTitle: 'Deleted “{{name}}”',
    nowUncategorized: 'Now uncategorized: {{names}}.',
    noneUncategorized: 'No cohort was left uncategorized.',
    viewsKeepFilters: 'Views keep their saved filters.',
    editDescription: 'Edit description',
    renameCohortTitle: 'Rename “{{name}}”',
    editDescriptionTitle: 'Edit description of “{{name}}”',
    cohortName: 'Name',
    cohortNamePlaceholder: 'Cohort name',
    cohortDescription: 'Description',
    cohortDescriptionPlaceholder: 'Describe who this cohort selects',
    cohortUpdated: 'Updated {{name}}',
    moveTo: 'Move to…',
    saveAsView: 'Save as view',
    moveCohortTitle: 'Move “{{name}}” to…',
    dragCohort: 'Drag {{name}}',
    dragCategory: 'Reorder category {{name}}',
    moving: 'Moving…',
    moveUp: 'Move up',
    moveDown: 'Move down',
    dragCohortHint: 'Drag to another category, or press Enter to choose a category from a list.',
    dragCategoryHint:
      'Drag to reorder, or press Enter to open the category menu with Move up and Move down.',
    moved: 'Moved {{cohort}} to {{category}}',
    moved_published:
      'Moved {{cohort}} to {{category}}. {{category}} is now published and appears in Filters.',
    movedFromOrganization:
      'Moved {{cohort}} from {{from}} to {{to}}. It left {{from}} in every workspace',
    movedFromOrganization_published:
      'Moved {{cohort}} from {{from}} to {{to}}. It left {{from}} in every workspace. {{to}} is now published and appears in Filters.',
    moveScopeRefused: '{{cohort}} belongs to {{workspace}}. Put it in a {{workspace}} category.',
    undo: 'Undo',
    moveUndone: 'Undid the move of {{cohort}}.',
    undoWait: 'Wait for the current move to finish',
    cantUndo: 'Can’t undo: {{cohort}} has moved since',
    categoryMovedBefore: '{{category}} now comes before {{before}} in Filters',
    categoryMovedLast: '{{category}} is now last in its block',
    addToCategory: 'Add to category…',
    addToCategoryTitle: 'Add “{{name}}” to a category',
    searchCategories: 'Search categories',
    noOtherCategories: 'No other categories match.',
    alsoPublishes: 'Also publishes the category',
    added: 'Added {{cohort}} to {{category}}.',
    addedAndPublished:
      'Added {{cohort}} to {{category}}. {{category}} is now published and appears in Filters.',
    showInDashboards: 'Show in Studio dashboards',
    hideFromDashboards: 'Hide from Studio dashboards',
    dashboardVisibility: 'Shown in Studio dashboards',
    shownInDashboards: '“{{name}}” is shown in Studio dashboards.',
    hiddenFromDashboards: '“{{name}}” is hidden from Studio dashboards.',
    removeFrom: 'Remove from {{category}}',
    removedStaysIn: 'Removed {{cohort}} from {{category}}. It stays in {{others}}.',
    removedUncategorized: 'Removed {{cohort}} from {{category}}. It is now uncategorized.',
    deleteCohort: 'Delete cohort',
    deleteCohortTitle: 'Delete “{{name}}”?',
    deleteCohortLeaves: 'It leaves {{categories}} in Filters.',
    deleteCohortUncategorized: 'It is in no category.',
    noViewUsesIt: 'No view uses it.',
    emptyAfterDelete_one:
      '{{categories}} then has no cohorts and its Filters section is hidden until it has one.',
    emptyAfterDelete_other:
      '{{categories}} then have no cohorts and their Filters sections are hidden until they have one.',
    cohortDeleted: 'Deleted {{name}}.',
    checkingUsage: 'Checking…',
    usageNotFound: 'This cohort no longer exists.',
    usageFailed: 'Could not check where this cohort is used.',
    cannotDeleteTitle: 'Can’t delete {{name}} yet — it is used.',
    usedByList: 'Used by:',
    blockingView: 'View “{{name}}”',
    blockingViewOtherWorkspace: 'View “{{name}}” in another workspace',
    blockingCohort: 'Cohort “{{name}}”',
    blockingCohortOtherWorkspace: 'Cohort “{{name}}” in another workspace',
    blockingEmailAutomation: 'Email automation “{{name}}” ({{flavour}})',
    emailAutomationFlavour: {
      weekly_patient_update: 'weekly patient update',
      rollup: 'rollup email',
      patient_note: 'patient note',
    },
    emailAutomationGeneric: 'email automation',
    blockingContext: 'Used by “{{name}}”',
    blockingHiddenDrafts_one: '{{count}} draft cohort by other users',
    blockingHiddenDrafts_other: '{{count}} draft cohorts by other users',
    blockingViewExcluded: '(excluded)',
    blockingViewBase: '(as base)',
    blockedHint:
      'Remove it from these first. A view stops using a cohort only when you delete the view or save a new one without it.',
    drafts: {
      title: 'Not published yet',
      publishedHeading: 'Published',
      loadFailed: 'Could not load your drafts.',
      untitled: 'Untitled draft',
      memberCount_one: '{{count}} patient',
      memberCount_other: '{{count}} patients',
      open: 'Open',
      discard: 'Discard',
      discarded: 'Discarded. Nothing clinicians see has changed.',
      gone: 'This draft no longer exists.',
      discardFailed: 'Could not discard this draft. Try again.',
      holderWorkspaceUnreachable:
        'This draft is open in a setup chat in a workspace you can’t switch to.',
      holderChatUnavailable: 'This draft is open in a setup chat you can’t open here.',
      draftWorkspaceUnreachable: 'This draft is in a workspace you can’t switch to.',
      draftChatUnavailable: 'The setup chat isn’t available here right now.',
    },
    errors: {
      dashboardVisibilityForbidden:
        'You can’t change whether this cohort is shown in Studio dashboards.',
      generic:
        'The result of this change is unknown. The list was refreshed; check it before making another change.',
      genericRefreshFailed:
        'The result of this change is unknown. Couldn’t refresh the list; reload the page before making another change.',
      notAllowed: 'Only OneStep staff can change cohorts and categories.',
      otherAuthorsDraft: 'This draft belongs to another author, so only they can change it.',
      notFound: 'This cohort or category no longer exists. The list was refreshed.',
      notFoundRefreshFailed:
        'This cohort or category no longer exists. Couldn’t refresh the list; reload the page.',
      revisionConflict:
        'Someone else changed this first. The list was refreshed with their change; check it and make your change again if it still applies.',
      revisionConflictRefreshFailed:
        'Someone else changed this first. Couldn’t refresh the list; reload the page before making your change again.',
      nameTaken: 'Another published object already uses this name. Pick another name.',
      nameConflict: 'A {{object}} named “{{name}}” already exists in {{scope}}. Pick another name.',
      nameConflictOnPublish:
        'Adding this cohort would publish the category, but a published {{object}} named “{{name}}” already exists in {{scope}}. Rename the category first.',
      nameWarning:
        'A published {{object}} named “{{name}}” already exists in {{scope}}. Rename this draft before it can be published.',
      managedByWorkingCopy:
        'This cohort is being edited with the agent, so it can’t be changed here. Publish or discard that draft first.',
      inUse: 'This cohort is still used by a view, so it can’t be deleted.',
      dependentBreak: 'This change would break other things that use it.',
      slugReserved: 'This name is reserved. Pick another name.',
      memberUnavailable: 'A cohort used here is no longer available.',
      parametersUnsupported: 'A cohort with settings can’t be changed here. Use the setup chat.',
      categoryScopeMismatch: 'Categories can only be reordered within their own scope block.',
      scopeMismatch:
        '“{{cohort}}” belongs to {{workspace}} and can only be in a workspace category.',
      categoryChanged:
        'The category changed while you were adding. The list was refreshed; pick the category again.',
      categoryChangedRefreshFailed:
        'The category changed while you were adding. Couldn’t refresh the list; reload the page.',
      conflictRefreshFailed:
        'This conflicts with the current state of the list. Couldn’t refresh the list; reload the page.',
      conflict:
        'This conflicts with the current state of the list, which was refreshed. Check it and make your change again if it still applies.',
    },
    addToRoster: 'Add to roster',
    onTheRoster: 'On the roster',
    addedToRoster: 'Added. Clinicians now see it as a card on the roster.',
    askSetupChatToAdd: 'You can also ask the setup chat: “Add {{name}} to the roster.”',
    blockingHiddenViews_one: '{{count}} view you can’t see uses this cohort',
    blockingHiddenViews_other: '{{count}} views you can’t see use this cohort',
    blockingHiddenViews_named_one: '{{count}} other view you can’t see also uses this cohort',
    blockingHiddenViews_named_other: '{{count}} other views you can’t see also use this cohort',
    hiddenViewsUse_one: '{{count}} view you can’t see uses it',
    hiddenViewsUse_other: '{{count}} views you can’t see use it',
  },
};
